"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = Object.freeze((0, _keyMirror.default)({
  MARKETING_IMAGE_SMALL: null,
  SCREENSHOT: null,
  // NOTE: These are temporary until images are returned as arrays
  MODULE_IMAGE_1: null,
  MODULE_IMAGE_2: null,
  MODULE_IMAGE_3: null,
  MODULE_IMAGE_4: null,
  MODULE_IMAGE_5: null
}));

exports.default = _default;
module.exports = exports.default;